import type { FillerVideoPreviewsQuery } from '@/generated/filler-previews';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_FILLER_VIDEO_PREVIEWS } from '@/queries/filler-previews';
import { buildFillerPreviewSources } from '@/lib/preview/fillerPreviewSources';

/** Separate from the catalog query: older APIs keep their working catalog and
 * original playback while this additive, optional operation is unavailable. */
export function useFillerPreviewSources() {
  const { data } = useQuery<FillerVideoPreviewsQuery>(GET_FILLER_VIDEO_PREVIEWS, {
    errorPolicy: 'ignore', fetchPolicy: 'cache-first',
  });
  return useMemo(() => buildFillerPreviewSources(data?.fillerVideos ?? []), [data]);
}
